/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

import template from './external-iframe-widget.component.html';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'adn-external-iframe-widget',
  template
})
export class ExternalIframeWidgetComponent implements OnInit {
  @Input() widgetType: any;

  url: string;
  hasHttps = false;
  height: number;
  trustedUrl: SafeResourceUrl;

  constructor(
    private readonly sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    this.url = this.widgetType?.url;
    this.hasHttps = _.startsWith(this.url, 'https');
    this.height = this.widgetType?.height;
    if (this.url && this.hasHttps) {
      this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
  }
}
